import UserAliases from './user-aliases';

export default function UserAliasesPage() {
  return <UserAliases />;
}
